import { Options } from 'ky';
import config from 'config';
import { Receipt, Settings } from 'CoreApi.Settings_V12';
import { useAuthenticatedApiClient } from 'utils/apiClient/base';

const clientOpts: Options = {
  prefixUrl: `${config.CORE_URL}/api`,
};

const headers = {
  'Content-type': 'application/json',
};

/* eslint-disable import/prefer-default-export */
export default function useStoreApi() {
  const authenticatedApiClient = useAuthenticatedApiClient().extend(clientOpts);

  return {
    getStoreSettings: () =>
      authenticatedApiClient
        .get('account/', {
          timeout: 60000,
        })
        .json<Settings>(),

    postStoreSettings: (payload: Partial<Settings>) =>
      authenticatedApiClient
        .post('account/', {
          headers,
          body: JSON.stringify(payload),
        })
        .json(),
    getReceiptPreview: (payload: any) =>
      authenticatedApiClient
        .post('basket/test-print/', {
          headers,
          body: JSON.stringify(payload),
        })
        .json<Receipt>(),
    uploadAccountImage: (data: FormData) =>
      authenticatedApiClient
        .post('account/image/', {
          body: data,
        })
        .json<Settings>(),
    deleteAccountImage: () => authenticatedApiClient.delete('account/image/'),
    postAccountSync: async (payload: {
      is_calendar_account_sync_enabled: boolean;
    }) => {
      const response = await authenticatedApiClient.post('account/sync/', {
        headers,
        body: JSON.stringify({
          enable: payload.is_calendar_account_sync_enabled,
        }),
        throwHttpErrors: false,
      });

      if (response.status !== 200) {
        const result = await response.json();
        throw new Error(JSON.stringify(result.error));
      }

      return { status: response.status };
    },
  };
}
